// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._2rko1l7b{border-radius:3px}._19bvv77o{padding-left:var(--ds-space-025,2px)}
._bfhk1v65{background-color:var(--_1kd7x7o)}
._ca0qidpf{padding-top:0}
._jqf61teg{label:tooltip-shortcut}
._n3tdidpf{padding-bottom:0}
._u5f3v77o{padding-right:var(--ds-space-025,2px)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/emoji/dist/esm/components/common/ToolTipContentWithKeymap.compiled.css"],"names":[],"mappings":";AACA,WAAW,iBAAiB,CAAC,WAAW,oCAAoC;AAC5E,WAAW,gCAAgC;AAC3C,WAAW,aAAa;AACxB,WAAW,sBAAsB;AACjC,WAAW,gBAAgB;AAC3B,WAAW,qCAAqC","sourcesContent":["\n._2rko1l7b{border-radius:3px}._19bvv77o{padding-left:var(--ds-space-025,2px)}\n._bfhk1v65{background-color:var(--_1kd7x7o)}\n._ca0qidpf{padding-top:0}\n._jqf61teg{label:tooltip-shortcut}\n._n3tdidpf{padding-bottom:0}\n._u5f3v77o{padding-right:var(--ds-space-025,2px)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
